// Retour intelligent + animation « vol vers le panier ».

// Revient à la page précédente de l'historique ; si le client est arrivé directement sur cette page
// (lien partagé, publicité), il n'y a pas de page précédente dans le site : on va vers `fallback`.
export function goBack(navigate, fallback = "/") {
  const idx = typeof window !== "undefined" ? (window.history.state && window.history.state.idx) || 0 : 0;
  if (idx > 0) navigate(-1);
  else navigate(fallback);
}

// Une pastille (photo du produit si fournie) part de `sourceEl` et vole jusqu'au panier, qui fait ensuite un petit rebond.
// Cible : le bouton panier du header s'il est visible à l'écran (sur l'accueil le header ne reste pas collé en haut),
// sinon la barre « Voir mon panier » du bas. Respecte « réduire les animations » (rebond seulement).
export function flyToCart(sourceEl, imgSrc) {
  try {
    if (!sourceEl) return;
    const s = sourceEl.getBoundingClientRect();
    // petit délai : à la toute première ajout, la barre du bas n'est pas encore affichée
    setTimeout(() => {
      try {
        const visible = (el) => { if (!el) return false; const r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight; };
        const head = document.querySelector('[data-testid="open-cart-btn"]');
        const bar = document.querySelector('[data-testid="mobile-floating-cart-btn"]');
        const target = visible(head) ? head : (visible(bar) ? bar : null);
        if (!target) return;
        const bump = () => target.animate(
          [{ transform: "scale(1)" }, { transform: "scale(1.3)" }, { transform: "scale(1)" }],
          { duration: 400, easing: "ease-out" }
        );
        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) { bump(); return; }
        const t = target.getBoundingClientRect();
        const size = 56;
        const dot = document.createElement(imgSrc ? "img" : "div");
        if (imgSrc) { dot.src = imgSrc; dot.alt = ""; dot.style.objectFit = "cover"; }
        Object.assign(dot.style, {
          position: "fixed", zIndex: "99999", pointerEvents: "none",
          left: `${s.left + s.width / 2 - size / 2}px`, top: `${s.top + s.height / 2 - size / 2}px`,
          width: `${size}px`, height: `${size}px`, borderRadius: "50%",
          background: "#dfff00", border: "2px solid #dfff00", boxShadow: "0 6px 24px rgba(223,255,0,.45)",
        });
        document.body.appendChild(dot);
        const dx = t.left + t.width / 2 - (s.left + s.width / 2);
        const dy = t.top + t.height / 2 - (s.top + s.height / 2);
        const anim = dot.animate(
          [
            { transform: "translate(0px, 0px) scale(1)", opacity: 1 },
            { transform: `translate(${dx * 0.55}px, ${dy * 0.55 - 70}px) scale(0.7)`, opacity: 1, offset: 0.55 },
            { transform: `translate(${dx}px, ${dy}px) scale(0.18)`, opacity: 0.5 },
          ],
          { duration: 750, easing: "cubic-bezier(0.4, 0, 0.2, 1)" }
        );
        anim.onfinish = () => { dot.remove(); bump(); };
        anim.oncancel = () => dot.remove();
      } catch { /* l'animation ne doit jamais bloquer l'ajout au panier */ }
    }, 60);
  } catch { /* idem */ }
}
